export default class RoomsCache {
    static getInstance() {
        if (!this._instance) {
            this._instance = new RoomsCache();
        }
        return this._instance;
    }
    constructor() {
        this._rooms = new Map();
    }
    getRoom(index) {
        return this._rooms[index];
    }
    hasRoom(index) {
        return this._rooms.has(index);
    }
    setRoom(value, index) {
        this._rooms[index] = value;
    }
}
